import { getYoutubeId } from "../../../../Utils/utils";
import "./index.css";
import React from "react";

export default function VideoPlayer({
  src,
  className,
  isUploadedVideo,
  controls = true,
}) {
  return isUploadedVideo ? (
    <video controls={controls} className={className}>
      <source src={src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <iframe
      title="video"
      width="100%"
      height="100%"
      src={`//www.youtube.com/embed/${getYoutubeId(
        src
      )}?modestbranding=1&showinfo=0`}
      allowFullScreen
      className={className}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/Package/components/VideoPlayer/index.js